import { Address, Credit } from '@kanda-libs/ks-frontend-services';

import { formatDate } from 'utils';

export interface BaseCreditInfo {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  customerAddress: string;
}

export interface FormattedCredit extends BaseCreditInfo {
  id: string;
  rate: string;
  provider: string;
  xid: string;
  createdAt: string;
  updatedAt: string;
}

const formatAddress = (address?: Address): string => {
  if (!address) return '--';
  const toCheck = address?.building_number || address?.building_name;
  const checkLine1 = toCheck ? address.line_1.includes(toCheck) : true;
  return [
    checkLine1 ? undefined : address?.building_number || address?.building_name,
    address?.line_1,
    address?.line_2,
    address?.city,
    address?.postcode,
  ]
    .filter(Boolean)
    .join(', ');
};

export const formatBaseCreditInfo = (credit: Credit): BaseCreditInfo => ({
  customerName:
    [credit?.customer_details?.first_name, credit?.customer_details?.last_name]
      .filter(Boolean)
      .join(' ') || '--',
  customerEmail: credit?.customer_details?.email || '--',
  customerPhone: credit?.customer_details?.mobile || '--',
  customerAddress: formatAddress(credit?.customer_details?.current_address),
});

export const formatCreditData = (
  credits: Credit[] | undefined,
): FormattedCredit[] => {
  if (!credits) return [];
  return credits.map(
    (credit: Credit): FormattedCredit => ({
      id: credit?.id || '--',
      rate: credit.finance_option.name,
      xid: credit?.xid || '--',
      provider: credit.finance_option.provider,
      ...formatBaseCreditInfo(credit),
      createdAt: formatDate(
        credit?.metadata?.created_at
          ? new Date(credit.metadata.created_at)
          : undefined,
        'YYYY-MM-DD',
      ),
      updatedAt: formatDate(
        credit?.metadata?.updated_at
          ? new Date(credit.metadata.updated_at)
          : undefined,
        'YYYY-MM-DD',
      ),
    }),
  );
};
